import { z } from 'zod';
import { createDateTimeSchema, createZodFormResolver, Validation } from '@mews/framework';

export enum ServiceOrderFormField {
    LinkedReservationId = 'linkedReservationId',
    SegmentId = 'segmentId',
    Value = 'value',
    StartUtc = 'startUtc',
    Note = 'note',
    ProductOrders = 'productOrders',
    TaxValues = 'taxValues',
    Currency = 'currency',
}

export enum ProductOrdersField {
    ProductId = 'productId',
    UnitCost = 'unitCost',
    Count = 'count',
    ProductCurrency = 'productCurrency',
}

const productOrderSchema = z.object({
    productId: Validation.String.Required,
    unitCost: z.number().nullish(),
    count: z.number().nullish(),
    productCurrency: z.string(),
});

export type ProductOrderFormValues = z.infer<typeof productOrderSchema>;

const createSchema = ({ notesRequired }: { notesRequired: boolean }) =>
    z
        .object({
            [ServiceOrderFormField.LinkedReservationId]: z.string().nullish(),
            [ServiceOrderFormField.SegmentId]: z.string().nullish(),
            [ServiceOrderFormField.Currency]: z.string(),
            [ServiceOrderFormField.Value]: z.number(),
            [ServiceOrderFormField.StartUtc]: Validation.DateTime.Utc,
            [ServiceOrderFormField.Note]: notesRequired ? Validation.String.Required : z.string().nullish(),
            // some services can have products required, but it's checked on the backend after submit
            [ServiceOrderFormField.ProductOrders]: z.array(productOrderSchema).nullish(),
            [ServiceOrderFormField.TaxValues]: z.record(z.string()),
        })
        .extend<{}>(createDateTimeSchema({ fieldName: ServiceOrderFormField.StartUtc, required: true }));

export type AddProductFormValues = z.infer<ReturnType<typeof createSchema>>;

export const createResolver = ({ notesRequired = false }: { notesRequired: boolean }) => {
    const schema = createSchema({ notesRequired });
    return createZodFormResolver<AddProductFormValues>(schema);
};
